var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10px",
    height: "10px",
    viewBox: "0 0 2000.000000 2105.000000",
    preserveAspectRatio: "xMidYMid meet",
    stroke: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2105.000000) scale(0.100000,-0.100000)",
    fill: "#FF0000",
    stroke: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7870 20535 c-2110 -508 -2125 -512 -2123 -536 1 -13 320 -1346 708 -2963 388 -1616 704 -2940 703 -2941 -2 -2 -1292 444 -2868 990 -1970 683 -2867 990 -2872 982 -3 -7 -315 -910 -693 -2007 -378 -1097 -695 -2018 -705 -2046 l-18 -52 71 -26 c40 -14 234 -81 432 -150 1272 -439 5773 -1996 5788 -2001 10 -4 17 -11 15 -16 -2 -4 -1038 -1103 -2303 -2441 -1265 -1338 -2300 -2435 -2300 -2439 0 -13 3146 -3010 3155 -3007 5 2 946 1000 2091 2218 1145 1218 2085 2216 2088 2217 3 2 325 -1327 716 -2953 390 -1626 712 -2957 715 -2959 5 -3 4258 1014 4268 1020 1 1 -318 1333 -708 2960 -391 1627 -708 2960 -706 2963 3 2 1295 -455 2872 -1018 1576 -562 2869 -1018 2873 -1014 5 5 216 606 470 1335 l461 1326 -2 808 -3 809 -2895 1028 c-1592 565 -2906 1031 -2918 1036 -22 7 174 214 2293 2421 1274 1327 2315 2416 2313 2421 -3 7 -3107 2971 -3140 2997 -13 11 -318 -304 -2114 -2176 -1197 -1248 -2102 -2184 -2105 -2178 -3 7 -325 1338 -714 2960 -390 1621 -711 2947 -714 2946 -3 -1 -962 -232 -2131 -514z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/iconStar.204756890d97ce0ee446da5fafe33f83.svg";
export { ForwardRef as ReactComponent };